export default __webpack_public_path__ + "static/flag-lu-140eeae9698fda8ea3ccef525a997681.svg";